import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { useFilterBarValues } from '../FilterBar.context'
import { FilterDropdown } from './FilterDropdown'

// A questionnaire whose sender pre-answered some questions, in its answer
// view: the questions needing an answer or the other ones, one view at a time.
// `defaultView` is the one shown while the URL names none. The options (with
// counts) come from the questions on the page.
export const QuestionViewFilterDropdown = React.memo(
  ({
    defaultView,
    isNested = false,
  }: {
    defaultView?: string
    isNested?: boolean
  }): JSX.Element => {
    const filterValues = useFilterBarValues().transformFilter(
      FilterParam.QUESTION_VIEW,
      'questionViews',
    )
    return (
      <FilterDropdown
        filterParam={FilterParam.QUESTION_VIEW}
        filterName={FilterName.QUESTION_VIEW}
        filterValues={filterValues}
        defaultSelection={defaultView ? [defaultView] : undefined}
        isNested={isNested}
        isSingleSelect
      />
    )
  },
)
